export const getInitialRenderValue=(min,max)=>{const maxLowerThanZero=max&&max<0;return min&&min>0||min&&maxLowerThanZero?min:!min&&maxLowerThanZero?max:0};